/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { emailRegex } from 'helpers/validators';
import { Form, Modal } from 'cvlib';

import { useDispatch, useSelector } from 'react-redux';
import {
  clearResetPasswordData,
  sendRecoveryPasswordEmail,
} from 'action-creators/forgot-password';
import { setMetricsEvent } from 'action-creators/metrics';
import { DEFAULTS_FORGOTTEN_PASSWORD_METRIC, METRICS as m } from '../constants';
import './ForgotPassword.scss';
import Metrics from 'services/metrics';

const ForgotPassword = props => {
  const { email, onCancelClicked } = props;
  const [emailToSend, setEmailToSend] = useState(email);
  const [status, setStatus] = useState('');

  const {
    sendLink_modal_title_label,
    login_access_placeHolder_textfield,
    password_tooltip_completeField_label_validation,
    email_tooltip_valid_label_validation,
    passwordRecovery_access_sendLink_label,
    passwordRecovery_access_description_label,
    passwordRecovery_access_title_label,
    resendLink_modal_title_label,
    passwordRecovery_access_option_button_cancel,
    passwordRecovery_access_option_button_next,
    resendLink_modal_description_label,
    resendLink_modal_option_button_getNewPassword,
    resendLink_modal_option_button_close,
    sendLink_modal_option_button_close,
    sendLink_modal_description_label,
    loginMail_tooltip_error_label,
  } = props.translations;

  const dispatch = useDispatch();
  const { error, data } = useSelector(state => state.resetPassword);
  const [modalVisible, setModalVisible] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const onRecoveryMetrics =  (userInfo) => {
    Metrics.newEvent({
      ...DEFAULTS_FORGOTTEN_PASSWORD_METRIC,
      client_id: window?.ga?.getAll()?.[0].get('clientId'),
      client_id_custom: window?.ga?.getAll()?.[0].get('clientId'),
      user_id: userInfo?.id_usuario,
      user_id_custom: userInfo?.id_usuario,
      timestamp_micros: Date.now() * 1000,
      page_title: 'olvidaste tu contraseña',
      engagement_time_msec: 0,
      interaction_type: passwordRecovery_access_option_button_next,
    });
  }

  const handleResendEmail = async () => {
    dispatch(sendRecoveryPasswordEmail(emailToSend, onRecoveryMetrics));
    
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const sendMetrics = params => {
    dispatch(
      setMetricsEvent({
        tagManager: {
          ...params,
        },
      }),
    );

    dispatch(
      setMetricsEvent({
        type: m.EXECUTOR,
        success: true,
      }),
    );
  };

  useEffect(
    () => {
      if (error && error !== 'unknown result') {
        setStatus('sended');
        setModalVisible(true);
      } else if (error && error === 'unknown result') {
        setInvalidEmail(true);
      }
    },
    [error],
  );

  useEffect(
    () => {
      if (data.email_sent) {
        setStatus('sended');
        if (data.attemp >= 6) {
          setModalVisible(true);
        }
      }
    },
    [data],
  );

  const elements = [
    {
      element: 'title',
      content: passwordRecovery_access_title_label,
      position: 'top',
      expand: 0.1,
    },
    {
      element: 'subtitle',
      content: passwordRecovery_access_description_label,
      position: 'top',
      expand: 0.2,
    },
    {
      element: 'item',
      type: 'email',
      placeholder: login_access_placeHolder_textfield,
      message: email_tooltip_valid_label_validation,
      error: invalidEmail && loginMail_tooltip_error_label,
      name: 'emailLogin',
      id: 'emailLogin',
      value: emailToSend,
      position: 'top',
      autoFocus: true,
      expand: 0.05,
      onChange: ({ target }) => {
        setEmailToSend(target.value);
        setInvalidEmail(false);
      },
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
        pattern: {
          value: emailRegex,
          message: email_tooltip_valid_label_validation,
        },
      },
    },
    {
      element: 'message',
      position: 'top',
      expand: 0.05,
      content: passwordRecovery_access_sendLink_label,
    },
    {
      element: 'button',
      position: 'top',
      expand: 0.05,
      content: passwordRecovery_access_option_button_next,
      submit: handleResendEmail,
      type: 'red',
    },
    {
      element: 'button',
      type: 'gray',
      position: 'top',
      expand: 0.2,
      content: passwordRecovery_access_option_button_cancel,
      onClick: () => {
        onCancelClicked();
        setStatus('');
        setModalVisible(false);
        dispatch(clearResetPasswordData());
        sendMetrics({
          event: m.EVENT.LOGIN,
          eventCategory: m.CATEGORY.LANDING,
          eventAction: m.ACTION.LOGIN,
          eventLabel: m.LABEL.FORGET_PASSWORD_CANCEL,
        });
      },
    },
  ];

  const modalElements = [
    {
      element: 'title',
      content: resendLink_modal_title_label,
      position: 'top',
    },
    {
      element: 'subtitle',
      content: resendLink_modal_description_label,
      position: 'top',
    },
    {
      element: 'button',
      type: 'red',
      content: resendLink_modal_option_button_getNewPassword,
      submit: () => {
        setStatus('');
        setModalVisible(false);
      },
    },
    {
      element: 'button',
      type: 'gray',
      content: resendLink_modal_option_button_close,
      onClick: handleCancel,
    },
  ];
  const elementsSended = [
    {
      element: 'title',
      content: sendLink_modal_title_label,
      position: 'top',
      expand: 0.1,
    },
    {
      element: 'subtitle',
      content: sendLink_modal_description_label?.replace(
        '{@EMAIL}',
        emailToSend,
      ),
      position: 'top',
      expand: 0.2,
    },
    {
      element: 'button',
      position: 'top',
      expand: 0.05,
      content: sendLink_modal_option_button_close,
      submit: () => {
        setStatus('');
        setModalVisible(false);
        
        const userInfo = JSON.parse(
          localStorage.getItem('getUserInfo') || '{}',
        );
        Metrics.newEvent({
          ...DEFAULTS_FORGOTTEN_PASSWORD_METRIC,
          client_id: window?.ga?.getAll()?.[0].get('clientId'),
          client_id_custom: window?.ga?.getAll()?.[0].get('clientId'),
          user_id: userInfo?.id_usuario,
          user_id_custom: userInfo?.id_usuario,
          timestamp_micros: Date.now() * 1000,
          page_title: 'olvidaste tu contraseña',
          engagement_time_msec: 0,
          interaction_type: sendLink_modal_option_button_close,
        });
        dispatch(clearResetPasswordData());
      },
      type: 'red',
    },
  ];

  return (
    <>
      <Modal isOpen={modalVisible}>
        <Form elements={modalElements} classes={['ForgotModal']} />
      </Modal>
      <Form
        elements={status === 'sended' ? elementsSended : elements}
        classes={['ForgotForm']}
      />
    </>
  );
};

ForgotPassword.propTypes = {
  email: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    sendLink_modal_title_label: PropTypes.string,
  }),
};

export default ForgotPassword;
